import { render, staticRenderFns } from "./UiVirtualList.vue?vue&type=template&id=62081fc6&scoped=true"
import script from "./UiVirtualList.vue?vue&type=script&lang=js"
export * from "./UiVirtualList.vue?vue&type=script&lang=js"
import style0 from "./UiVirtualList.vue?vue&type=style&index=0&id=62081fc6&prod&lang=scss&scoped=true"
import style1 from "./UiVirtualList.vue?vue&type=style&index=1&id=62081fc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62081fc6",
  null
  
)

export default component.exports